import React from "react";
import { Link } from "react-router-dom";
import { FiEdit3, FiUpload } from "react-icons/fi";
import useCallCenterT from "../../hooks/useCallCenterT";
import TicketUploadHistoryPanel from "../../components/call-center/TicketUploadHistoryPanel";
import {
  LISTING_CONTAINER_CLASS,
  LISTING_PAGE_CLASS,
} from "../../components/call-center/listing/listingStyles";

const CallCenterTicketUploadHistoryPage = () => {
  const t = useCallCenterT();

  return (
    <div className={LISTING_PAGE_CLASS}>
      <div className={LISTING_CONTAINER_CLASS}>
        <header className="mb-6 flex flex-wrap items-start justify-between gap-4">
          <div>
            <h1 className="text-[28px] font-bold tracking-tight text-[#111827]">
              {t("ccUploadHistoryPageTitle")}
            </h1>
            <p className="mt-1 text-sm text-[#6b7280]">{t("ccUploadHistoryPageSubtitle")}</p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <Link
              to="/call-center/ticket-bulk-upload"
              className="inline-flex h-10 items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
            >
              <FiUpload className="h-4 w-4" />
              {t("ccMenuTicketBulkUpload")}
            </Link>
            <Link
              to="/call-center/agent-workspace"
              className="inline-flex h-10 items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
            >
              <FiEdit3 className="h-4 w-4" />
              {t("ccMenuAgentWorkspace")}
            </Link>
          </div>
        </header>

        <TicketUploadHistoryPanel />
      </div>
    </div>
  );
};

export default CallCenterTicketUploadHistoryPage;
